<template>
  <!-- 关于我们>企业概况 -->
  <div class="detection" ref="detection" style="width: 100%">
    <!-- 页面头部 -->
    <pageHeader ref="pageHeader" pageStatus="6" />
    <div
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: stretch;
        justify-content: space-around;
      "
    >
      <div class="solution_bgbox" :class="[commonWidth]">
         <div style="background: #eaebee" class="commonFull">
            <img v-if="srcUrl" :src="srcUrl" class="commonFull" />
            <div :class="solutiondetailcontainersss">
                <p :class="[font40]">
                {{titleData.chName}}
                </p>
                <p :class="[font18]">{{titleData.esName}}</p>
            </div>
         </div>
        </div>
      <!-- 类型图片+类型简介 -->
      <div ref="detectionss" :style="{width: commonWidth}"
       class="detection_content">
        <!-- 左侧列表或者联系方式 -->
        <div class="detection_content_left">
          <div
            class="detection_content_left_box"
            :style="
              cssStatus == 0
                ? ''
                : cssStatus == 1
                ? 'position:sticky;top:0;z-index:1000;'
                : 'position:absolute;bottom:0;'
            "
            id="detection_content_left_box"
          >
        </div>
          <div class="detection_content_right">
            <div :style="{ display:commonDisplay }" class="detection_content_right_title">
              <div class="detection_content_right_title_right">
                <span style="cursor: pointer;" @click="toHome">首页</span>
                <i class="el-icon-arrow-right" v-if="$route.path != '/detection'"></i>
                <span
                  v-if="$route.path != '/detection'"
                  @click="toload"
                  style="cursor: pointer;color:#1E203C;"
                  >{{ leftData.title }}</span
                >
                <i class="el-icon-arrow-right"></i>
                <span style="cursor: pointer;color:#1E203C;">{{ rightData.name }}</span>
              </div>
            </div>
            <div :class=" commonBoom ? 'table-hader' : 'm_table_hader'" v-if="idclickStatus !== '10804'">
              <div v-for="(its, is) in menuList" :key="is" @click="tolist(its)">
                  <div
                    :class="commonDisplay==='block'?'detection_content_left_cont3_ever1':'ph-detection_content_left_cont3_ever1'"
                    :style="
                      its.id == idclickStatus
                        ? 'border-bottom:2px solid #122266;'
                        : ''
                    "
                    v-if="its.name"
                  >
                    <span
                      :class="commonBoom ? 'detection_content_left_cont3_ever_text' : 'm_detection_content_left_cont3_ever_text'"
                      :style="its.id == idclickStatus ? 'color:#122266;' : 'color:#64686E'"
                      >{{ its.name }}</span
                    >
                  </div>
              </div>
            </div>
          </div>
          <!-- 中心简介/认证证书/联系我们 -->
           <!-- || idclickStatus == '1080501' -->
          <div class="detection_content_right_cont16" v-if="idclickStatus == '1080101'  || idclickStatus == '10804'">
            <div :class="[detectioncontentrightcont16info,'solution_detail_container', solutiondetailcontainer]" v-html="rightdetail.content"></div>
          </div>
          <!-- 中心资质/大客户 -->
          <div :class="imgboxClass" v-if="idclickStatus == '1080102' || idclickStatus == '1080103'">
            <template v-if="list.length > 0">
              <div
                class="detection_content_right_cont9_ever"
                v-for="(item, index6) in list"
                :key="'item8' + index6"
              >
                <div class="classImg">
                  <el-image :z-index= "99999" :src="item.image" style="width: 270px; height: 180px" fit="fill" :preview-src-list="urllist"> </el-image>
                </div>
                <el-tooltip :disabled="item.title.length>=17?false:true" :visible-arrow = "false" placement="bottom" effect="dark">
                  <div slot="content"><div style="text-align: center;width: 250px;height: auto;word-wrap: break-word;">
                  {{ item.title }}
                  </div></div>
                  <div class="detection_content_right_cont9_ever_text">
                    {{ item.title }}
                  </div>
                </el-tooltip>
              </div>
              <template v-if="list.length % 4 > 0">
                <div
                  class="detection_content_right_cont9_list"
                  v-for="index7 in 4 - (list.length % 4)"
                  :key="'item9' + index7"
                ></div>
              </template>
            </template>
          </div>
          <!-- 双碳证书 -->
          <div :class="certBox" style="margin-top:20px;" v-if="idclickStatus == '1080502'">
            <div :class="certSearch">
              <div class="search-inpout">
                <el-input
                  placeholder="请输入证书编号"
                  v-model="certificateCode"
                >
                  <div class="input_search_btn" slot="append" @click="searchCertificate">查询</div>
                </el-input>
              </div>
            </div>
            <div style="margin-top: 20px">
              <template v-if="list.length > 0">
                <div
                  class="detection_content_right_cont8_ever"
                  v-for="(item, index6) in list"
                  :key="'item10' + index6"
                >
                  <div class="detection_content_right_cont8_ever_left" style="display:flex;align-items: center;width: calc( 100% - 80px);">
                    <img src="@/assets/icon-download.png" alt="" style="width: 26px; height: 26px;margin-right: 4px;" />
                    <div>{{item.fileName}}</div>
                  </div>
                  <div style="display:flex;align-items: center;">
                    <el-button style="width: 61px;height: 26px;font-size: 12px;color: #676e77;padding: 0 !important;" @click="open(item)">查看</el-button>
                  </div>
                </div>
              </template>
              <template v-if="list.length === 0 && isSearch">
                <div class="empty-box">
                  <img class="empty-img" src="@/assets/kong.png" alt="">
                  <div class="empty-text">当前数据为空</div>
                </div>
              </template>
            </div>
          </div>
          <!-- 申请文件/公开文件 -->
          <div v-if="idclickStatus == '1080301' || idclickStatus == '1080302' || idclickStatus == '1080303' || idclickStatus == '1080304'">
            <template v-if="list.length > 0">
              <div
                class="detection_content_right_cont8_ever"
                v-for="(item, index6) in list"
                :key="'item10' + index6"
              >
                <div class="detection_content_right_cont8_ever_left" style="display:flex;align-items: center;width: calc( 100% - 140px);">
                  <img src="@/assets/icon-download.png" alt="" style="width: 26px; height: 26px;margin-right: 4px;" />
                  <div>{{item.name}}</div>
                </div>
                <div style="display:flex;align-items: center;">
                  <el-button style="width: 61px;height: 26px;font-size: 12px;color: #676e77;padding: 0 !important;" @click="open(item)">预览</el-button>
                  <el-button v-if="idclickStatus == '1080301'" style="width: 61px;height: 26px;font-size: 12px;color: #676e77;padding: 0 !important;" @click="download(item)">下载</el-button>
                </div>
              </div>
            </template>
            <div v-if="idclickStatus == '1080302'" style="margin-top:20px;text-indent: 14px;font-size: 14px;">* 意向开展认证业务企业，可来访西安国联质量检测技术股份有限公司查看详细文件。</div>
            <div v-if="idclickStatus == '1080304'" style="margin-top:20px;text-indent: 14px;font-size: 14px;">* 本机构无分支或派出机构。</div>
          </div>
          <!-- 认证证书 -->
           <!-- 10806 -->
           <div v-if="idclickStatus == '1080501'" style="margin: 20px 0 50px;">
            <div :class="certcateSearch" style="display: flex;justify-content: center;">
               <div class="search-input">
                <el-input
                  placeholder="请输入获证组织名称"
                  v-model="companyName"
                >
                  <div class="input_search_btn" slot="append" @click="searchCertificateByName">查询</div>
                </el-input>
              </div>
            </div>
            <el-table :data="list" class="certificateStatus-table" :class="[mcertcateTable]" v-if="isSearchCertificate">
              <el-table-column :width="isPc ? '' : '106px'" prop="companyName" label="获证组织名称" align="center" show-overflow-tooltip />
              <el-table-column :width="isPc ? '' : '106px'" prop="cerSysName" label="认证项目" align="center" show-overflow-tooltip />
              <el-table-column :width="isPc ? '180px' : ''" prop="cerStatusStr" label="证书状态" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                <div class="cerStatus-con">
                    <div class="tag" :style="{background: (scope.row.cerStatus == 0 || scope.row.cerStatus == 1) ? '#dd503f' : scope.row.cerStatus == 2 ? '#727272' : scope.row.cerStatus == 3 ? '#63d645' : scope.row.cerStatus == 4 ? '#727272' : ''}"></div>
                    <div>{{ scope.row.cerStatusStr }}</div>
                </div>
                </template>
              </el-table-column>
              <el-table-column :width="isPc ? '180px' : '80px'" prop="cerStatusStr" label="认证信息" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                <div class="cerStatus-con">
                    <div style="color: #1E203C;cursor: pointer;" @click="previewCertificate(scope.row)">【预览】</div>
                </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div
            class="detection_content_right_footer"
            v-show="list.length > 0 && (idclickStatus == '1080102'  || idclickStatus == '1080103' || idclickStatus == '1080301' || idclickStatus == '1080302'  || idclickStatus == '1080303' || idclickStatus == '1080304')"
          >
            <pagination
              :pageindex="pageindex"
              :rows="rows"
              :total="total"
              :pageCount="isPc ? 7 : 5"
              @handle-changepage="currentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="下载验证码"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <span slot="footer" class="dialog-footer">
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <slide-verify
            ref="slideblock"
            :l="42"
            :r="10"
            :w="310"
            :h="155"
            :imgs="slideVerifyImgList"
            slider-text="向右滑动"
            @success="onSuccess"
            @fail="onFail"
            @refresh="onRefresh"
          ></slide-verify>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="体系认证证书查询"
      :visible.sync="certDialogVisible"
      :before-close="handleCloseCertDialog"
      top="40vh"
      :class="isPc ? 'certificateSearch-dialog' : 'mcertificateSearch-dialog'"
      :show-close="false"
      :center="true"
    >
      <el-input
        placeholder="请输入证书编号"
        v-model="certificateNumber"
        style="display: flex;justify-content: center;margin: 20px auto;"
      >
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCertDialog">取 消</el-button>
        <el-button class="certificateSearch-btn" @click="handleSureCertDialog" :loading="certDialogLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    pagination: () => import("@/components/pagination"),
    pageHeader: () => import("@/components/header"),
    contentTitle: () => import("@/components/contentTitle"),
  },
  metaInfo() {
    return {
      title: this.pageInfo.metaTitle, // set a title
      meta: [
        {
          // set meta
          name: "keyWords",
          content: this.pageInfo.metaKeywords,
        },
        {
          name: "description",
          content: this.pageInfo.metaDescription,
        },
      ],
    };
  },
  computed: {
    isPc(){
      return this.$vuetify.breakpoint.name != 'sm' && this.$vuetify.breakpoint.name != 'xs'
    },
    detectioncontentrightcont16info(){
      
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "phdetection_content_right_cont16_info";
        case "sm":
          return "phdetection_content_right_cont16_info";
        case "md":
          return "detection_content_right_cont16_info";
        case "lg":
          return "detection_content_right_cont16_info";
        case "xl":
          return "detection_content_right_cont16_info";
      }
    },
    solutiondetailcontainer(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "msolutiondetailcontainer";
        case "sm":
          return "msolutiondetailcontainer";
        case "md":
          return "pcsolutiondetailcontainer";
        case "lg":
          return "pcsolutiondetailcontainer";
        case "xl":
          return "pcsolutiondetailcontainer";
      }
    },
    solutiondetailcontainersss(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "solution_bg_titles";
        case "sm":
          return "solution_bg_titles";
        case "md":
          return "solution_bg_title";
        case "lg":
          return "solution_bg_title";
        case "xl":
          return "solution_bg_title";
      }
    },
    commonBoom() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return false
                case 'sm': return false
                case 'md': return true
                case 'lg': return true
                case 'xl': return true
            }
    },
    font40() {
        switch (this.$vuetify.breakpoint.name) {
            case "xs":
            return "m40";
            case "sm":
            return "m40";
            case "md":
            return "p40";
            case "lg":
            return "p40";
            case "xl":
            return "p40";
        }
        },
        font18() {
          switch (this.$vuetify.breakpoint.name) {
              case "xs":
              return "m18";
              case "sm":
              return "m18";
              case "md":
              return "p18";
              case "lg":
              return "p18";
              case "xl":
              return "p18";
          }
        },
    font18() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m18";
        case "sm":
          return "m18";
        case "md":
          return "p18";
        case "lg":
          return "p18";
        case "xl":
          return "p18";
      }
    },
    commonDisplay() {
        switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'none'
            case 'sm': return 'none'
            case 'md': return 'block'
            case 'lg': return 'block'
            case 'xl': return 'block'
        }
    },
    commonClass() {
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'ph-bigbox-center'
          case 'sm': return 'ph-bigbox-center'
          case 'md': return 'pc-bigbox-center'
          case 'lg': return 'pc-bigbox-center'
          case 'xl': return 'pc-bigbox-center'
      }
    },
    imgboxClass() {
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'ph-img-box'
          case 'sm': return 'ph-img-box'
          case 'md': return 'pc-img-box'
          case 'lg': return 'pc-img-box'
          case 'xl': return 'pc-img-box'
      }
    },
    commonWidth() {
        switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 100  + '%'
            case 'sm': return 100 + '%'
            case 'md': return 1200 + 'px'
            case 'lg': return 1200 + 'px'
            case 'xl': return 1200 + 'px'
        }
    },
    solutionBgHeight() {
        switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 220 + 'px'
            case 'sm': return 220 + 'px'
            case 'md': return 240 + 'px'
            case 'lg': return 240 + 'px'
            case 'xl': return 240 + 'px'
        }
    },
    srcUrl() {
        switch (this.$vuetify.breakpoint.name) {
            case 'xs': return require("@/assets/mcertification.png")
            case 'sm': return require("@/assets/mcertification.png")
            case 'md': return require("@/assets/certification.png")
            case 'lg': return require("@/assets/certification.png")
            case 'xl': return require("@/assets/certification.png")
        }
    },
    imgBox(){
      switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'img_box'
            case 'sm': return 'img_box'
            case 'md': return ''
            case 'lg': return ''
            case 'xl': return ''
        }
    },
    certSearch(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'mcert-search'
          case 'sm': return 'mcert-search'
          case 'md': return 'cert-search'
          case 'lg': return 'cert-search'
          case 'xl': return 'cert-search'
      }
    },
    certBox(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'mcert-box'
          case 'sm': return 'mcert-box'
          case 'md': return 'cert-box'
          case 'lg': return 'cert-box'
          case 'xl': return 'cert-box'
      }
    },
    certcateSearch(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'mcertcate-search'
          case 'sm': return 'mcertcate-search'
          case 'md': return 'certcate-search'
          case 'lg': return 'certcate-search'
          case 'xl': return 'certcate-search'
      }
    },
    mcertcateTable(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 'mcertificateStatus-table'
          case 'sm': return 'mcertificateStatus-table'
          case 'md': return 'pcertificateStatus-table'
          case 'lg': return 'pcertificateStatus-table'
          case 'xl': return 'pcertificateStatus-table'
      }
    }
  },
  data() {
    return {
      slideVerifyImgList: [
        require("@/assets/mguanyuguolian.png")
      ],
      imageLists:[],
      rightStatus: "16",
      pageSize: 12,
      pageInfo: {
        metaTitle: "认证中心",
        metaKeywords: "",
        metaDescription: "",
      },
      cssStatus: "0",
      rightData: {},
      idclickStatus: "",
      activeName: "1",
      leftData: {
        id: "10801",
        title: "认证中心",
      },
      titleData: {
        chName: "认证中心",
        esName: "Certification Center",
        text:
          "",
        imgUrl: require("@/assets/enterprise-top-pc.jpg"),
      },
      pageindex: 1,
      rows: 4,
      total: 0,
      list: [],
      menuList: [],
      urllist:[],
      pageCount: 0,
      rightdetail: {},
      width:0,
      columnId: null,
      dialogVisible: false,
      certificateCode: null,
      isSearch: false,
      columnType: null,
      companyName: null,
      certificateId: null,
      certDialogVisible: false,
      certificateNumber: null,
      certDialogLoading: false,
      isSearchCertificate: false,
    };
  },
  created() {
    this.columnId = this.$route.query.id
    this.columnType = this.$route.query.type || 0
    this.leftData.id = this.columnId
    this.getColumnList();
  },
  mounted() {
    const obj = {
        platformType : 0,
        targetPage : ''
        } 
        obj.targetPage =  window.location.href
        if (this.commonDisplay === 'block') {
            obj.platformType = 1
        } else {
            obj.platformType = 2
        }
        this.$api.iotHome.loggingData(obj)
            .then((res) => {
            if (res.data.success == true) {
            console.log('数据记录成功');
            }
      })
    this.width = this.$refs.detectionss.clientWidth;
  },
  destroyed() {
  },
  methods: {
    // 获取tab目录
    getColumnList() {
      this.$api.iotHome
        .columnList({
          parentId: this.leftData.id,
          siteId: "0",
        })
        .then((res) => {
          if (res.data.success == true) {
            if(res.data.data[0].children.length > 0) {
              this.menuList = res.data.data[0].children;
              this.rightData = this.menuList[0];
              this.idclickStatus = this.menuList[0].id;
            } else {
              this.menuList = res.data.data;
              this.rightData = this.menuList[0];
              this.idclickStatus = this.menuList[0].id;
            }
            // 设置关键字
            this.pageInfo = {
              metaTitle: this.rightData.name,
              metaKeywords: this.rightData.metaKeywords,
              metaDescription: this.rightData.metaDescription
            }
            if(this.columnType == 1){
              this.tolist(this.menuList[1])
            }
            this.getcontentByColumnId()
          }
        });
    }, 
    // tab切换
    tolist(data) {
      this.list = []
      this.urllist = []
      this.idclickStatus = data.id;
      this.rightData = data;
      this.pageInfo = {
        metaTitle: data.name,
        metaKeywords: data.metaKeywords,
        metaDescription: data.metaDescription
      }
      this.pageindex = 1;
      this.getcontentByColumnId()
    },
    // 根据目录获取内容
    getcontentByColumnId(){
      // 中心概况
      if(this.idclickStatus == '1080101') {
        // 中心简介/架构
        this.getArticleDetail()
      } 
      if(this.idclickStatus == '1080102' || this.idclickStatus == '1080103') {
        // 中心资质/大客户
        this.rows = 8
        this.getImgList()
      }
      // 证书查询
      // if(this.idclickStatus == '1080501') {
      //   // 认证证书
      //   this.getArticleDetail()
      // }
      // 下载专区
      if(this.idclickStatus == '1080301' || this.idclickStatus == '1080302' || this.idclickStatus == '1080303' || this.idclickStatus == '1080304') {
        this.rows = 10
        this.getFieList()
      }
      // 联系我们
      if(this.idclickStatus == '10804') {
        this.rows = 10
        this.getArticleDetail()
      }
      // 认证证书状态查询
      if(this.idclickStatus == '1080501') {
        this.rows = 10
        // this.getCertificateStatus()
        this.searchCertificateByName()
      }
    },
    // 获取文章列表下的第一个文章详情
    getArticleDetail() {
      this.$api.iotHome
        .getArticleList({
          columnId: this.idclickStatus
        })
        .then((res) => {
          if (res.data.success == true) {
            const data = res.data.data
            if(data.rows.length > 0) {
              this.$api.iotHome
                .getArticleById({
                  id: data.rows[0].id,
                })
                .then((res) => {
                  if (res.data.success == true) {
                    this.rightdetail = res.data.data;
                    this.rightdetail.content = this.rightdetail.content.replace(
                      /src="(?![http])/g,
                      'src="' + this.$path
                    );
                  }
                })
            }
          }
        })
    },
    // 获取图片相关列表
    getImgList() {
      const _that = this
      this.$api.iotHome
        .getImageList({
          columnId: this.idclickStatus,
          rows: this.rows,
          page: this.pageindex,
        })
        .then((res) => {
          if (res.data.success == true) {
              res.data.data.list.map(item => {
                item.image = this.$path + item.image;
                item.name = item.name;
                this.urllist.push(item.image)
              })
            }
            this.total = res.data.data.totalNum;
            this.pageCount = parseInt(this.total / this.rows);
            this.list = res.data.data.list;
        })
    },
    // 获取文件相关列表
    getFieList(){
      const _that = this
      this.$api.iotHome
        .getFieList({
          contentId: this.idclickStatus,
          rows: this.rows,
          page: this.pageindex,
        })
        .then((res) => {
          this.total = res.data.data.total;
          this.pageCount = parseInt(this.total / this.rows);
          this.list = res.data.data.rows;
        })
    },
    // 双碳证书查询
    searchCertificate() {
      this.isSearch = true
      this.certificateCode = this.certificateCode.trim()
      if(this.certificateCode) {
        this.$api.iotHome
          .getCertificateList({
            certificateCode2: this.certificateCode
          })
          .then((res) => {
            this.list = res.data.rows
          })
      } else {
        this.list = []
      }
    },
    // 根据获证名称查询证书列表
    searchCertificateByName() {
      if(this.companyName) {
        this.companyName = this.companyName.trim()
      }
      this.pageindex = 1
      if(this.companyName) {
        this.getCertificateStatus()
      } else {
        this.isSearchCertificate = false
        this.list = []
      }
    },
    // 获取认证证书状态查询
    getCertificateStatus() {
      this.isSearchCertificate = true
      const _that = this
      this.$api.iotHome
        .getCertificateStatusList({
          pageSize: 99,
          pageNum: this.pageindex,
          orderByColumn: 'updateTime',
          isAsc: 'desc',
          companyName: this.companyName || ''
        })
        .then((res) => {
          this.total = res.data.total;
          this.pageCount = parseInt(this.total / this.rows);
          if(this.companyName) {
            this.list = res.data.rows;
          } else {
            this.list = res.data.rows.slice(0, 10)
          }
        })
    },
    // 预览证书
    previewCertificate(data) {
      this.certDialogVisible = true
      this.certificateId = data.id
    },
    handleCloseCertDialog(){
      this.certDialogVisible = false
      this.certificateNumber = null
      this.certificateId = null
      this.certDialogLoading = false
    },
    handleSureCertDialog(){
      if(this.certDialogLoading) {
        return
      }
      if(!this.certificateNumber) {
        this.$message({
          message: '请输入证书编号',
          type: 'warning',
          duration: 1000
        })
        return
      }
      this.certDialogLoading = true
      this.$api.iotHome
        .getCertificateDetail({
          id: this.certificateId,
          certNo: this.certificateNumber
        })
        .then((res) => {
          if (res.data.rows.length > 0) {
            this.certDialogLoading = false
            this.$router.push({
              path: '/certificationDetail',
              query: {
                id: this.certificateId,
                certNo: this.certificateNumber
              }
            })
          } else {
            this.$message({
              message: '证书编号有误，请重新输入',
              type: 'warning',
              duration: 3000
            })
            this.certDialogLoading = false
          }
        })
    },
    // 预览
    open(data){
      if(data.url) {
        window.open(this.$path+data.url);
      }
      if(data.fileUrl) {
        window.open(this.$path+data.fileUrl);
      }
    },
    // 下载
    download(data) {
      window.localStorage.setItem(
        "pathUrl",
        this.$path + "/web/cms/download?fileId=" + data.id
      );
      this.dialogVisible = true;
    },
    onSuccess() {
      this.dialogVisible = false;
      this.$refs.slideblock.reset();
      this.msg = "";
      window.location.href = window.localStorage.getItem("pathUrl");
    },
    onFail() {
      this.msg = "";
    },
    onRefresh() {
      this.msg = "";
    },
    handleClose(done) {
      done();
    },
    // 分页点击
    currentChange(val) {
      this.list = [] 
      this.pageindex = parseInt(val);
      this.getcontentByColumnId()
    },
    // 图片放大
    previewImg(url) {
      this.$hevueImgPreview(url);
    },
    // 跳转上一级
    toload() {
      this.$router.go(0);
    },
    // 跳转首页
    toHome() {
      this.$router.push({
        path: "/",
      });
    }
  },
};
</script>
<style lang="scss">
.img_box{
  .el-image-viewer__img{
    clip-path: inset(0 60px 0 0)!important;
    margin-left: 60px!important;
  }
}
.cert-search,.mcert-search{
  .el-input-group__append, .el-input-group__prepend {
    border: none;
    background-color: #395FFF;
    padding: 0;
  }
}
.cert-search {
  .el-input__inner {
    width: 300px !important;
    height: 40px!important;
    line-height: 40px!important;
    font-size: 14px;
    background: transparent;
  }
}
.mcert-search{
  .el-input__inner {
    width: 200px !important;
    height: 30px!important;
    line-height: 30px!important;
    font-size: 12px;
    background: transparent;
  }
}
.certcate-search,.mcertcate-search{
  .el-input-group__append, .el-input-group__prepend {
    border: none;
    background-color: #1E203C;
    padding: 0;
  }
}
.certcate-search {
  .el-input__inner {
    width: 300px !important;
    height: 38px!important;
    line-height: 38px!important;
    font-size: 14px;
    background: transparent;
  }
}
.mcertcate-search{
  justify-content: center!important;
  .el-input__inner {
    width: 200px !important;
    height: 30px!important;
    line-height: 30px!important;
    font-size: 12px;
    background: transparent;
  }
  .input_search_btn {
    font-size: 12px;
  }
}
</style>
<style lang="scss" scoped>
@import url("../style/menu.css");
@import url("../style/contentRight.css");
p {
  text-align: justify !important;
}
.cert-search,.mcert-search {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .input_search_btn {
    width: 70px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    &:hover {
      opacity: 0.7;
    }
    &:active {
      opacity: 0.8;
    }
  }
}
.mcert-box{
  .empty-box {
    width: 100%;
    .empty-img {
      width: 4.88rem;
      height: 3.83rem;
      display: block;
      margin: 0 auto;
    }
    .empty-text {
      text-align: center;
      font-size: .3rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #A2A3B4;
    }
  }
}
.cert-box{
  .empty-box {
    width: 100%;
    .empty-img {
      width: 222px;
      height: 176px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .empty-text {
      margin-top: 41px;
      width: 100%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      color: #282B45;
      line-height: 19px;
      text-align: center;
    }
  }
}
.certcate-search,.mcertcate-search {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .input_search_btn {
    width: 70px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    &:hover {
      opacity: 0.7;
    }
    &:active {
      opacity: 0.8;
    }
  }
}


.industry_customer {
  width: 100%;
  margin-bottom: 80px;
  ul {
    display: flex;
    flex-flow: wrap;
    li {
      width: 240px;
      height: 118px;
      border-bottom: 1px solid #eaebee;
      border-right: 1px solid #eaebee;
      &:nth-child(5n) {
          border-right: none;
        }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.industry_customers {
  width: 100%;
  margin-bottom: 32px;
  ul {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    li {
      width: 33%;
      height: 59px;
      border-bottom: 1px solid #f4f6fc;
      border-right: 1px solid #f4f6fc;
      &:nth-child(3n) {
          border-right: none;
        }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.ph-detection_content_left_cont3_ever1 {
    height: 41px;
    display: -webkit-box;
    display: -ms-flexbox;
    float: left;
    -ms-flex-pack: justify;
    -webkit-box-align: center;
    -ms-flex-align: center;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;
}
.detection_content_right_cont16 {
  padding: 0 20px;
}
.detection_content_right_ptitle_pc{
  font-size: 18px!important;
  div:nth-child(1){
    margin-bottom: 20px;margin-top: 65px;text-indent: 30px;line-height: 33px;
  }
}
.detection_content_right_ptitle_ph{
  font-size: 14px!important;
  div:nth-child(1){
    margin-bottom: 20px;
    margin-top: 17px;
    margin-left: 21px;
    margin-right: 20px;
    text-indent: 30px;
    line-height: 30px;
    font-weight: 400;
  }
}
.commonFull {
  width: 100%;
  height: 100%;
}
.solution_bgbox {
  position: relative;
  margin: 0 auto;
  display: block;
  .solution_bg_title {
    position: absolute;
    top: 50%;
    left: 6%;
    transform: translate(0, -50%);
    color: #fff;
    
    font-weight: 600;
    text-align: left;
    line-height: 1;
  }
  .solution_bg_titles {
    display:none;
  }
  .solution_bg_title p:nth-child(2) {
    font-weight: 400;
    
    margin-top: 16px;
  }
}
.overflow-box {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
}
.ph-overflow-box {
  width: 64px;
  border-radius: 50%;
  overflow: hidden;
}
.bigBoxever_img {
  width:272px;
  height:432px;
  margin-left: 35px;
  .overflow-boxs {
    position: relative;
    width: 190px;
    height: 274px;
    overflow: hidden;
    margin: 0 auto;
    border-radius: 0 0 95px 95px;
    .background {
      position: absolute;
      width: 190px;
      height: 190px;
      bottom: 0;
      background-color: #A8DBFF;
      border-radius: 95px;
    }
    img {
      position: absolute;
      width:583px;
    }
  }
  .bigBoxever_img-name {
    
    font-size: 32px;
    color: #122266;
    text-align: center;
    font-weight: 500;
    margin-top: 24px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
  }
  .bigBoxever_img-text {
    
    font-size: 18px;
    color: #64686E;
    font-weight: 600;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bigBoxever_img-center {
    
    font-size: 16px;
    color: #64686E;
    text-align: center;
    font-weight: 400;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
}
.ph-bigBoxever_img {
  width:272px;
  height:432px;
  .overflow-boxs {
    position: relative;
    width: 190px;
    height: 274px;
    overflow: hidden;
    margin: 0 auto;
    border-radius: 0 0 95px 95px;
    .background {
      position: absolute;
      width: 190px;
      height: 190px;
      bottom: 0;
      background-color: #A8DBFF;
      border-radius: 95px;
    }
    img {
      position: absolute;
      width:583px;
    }
  }
  .bigBoxever_img-name {
    
    font-size: 16px;
    color: #122266;
    text-align: center;
    font-weight: 500;
    margin-top: 24px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
  }
  .bigBoxever_img-text {
    
    font-size: 14px;
    color: #64686E;
    font-weight: 600;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bigBoxever_img-center {
    
    font-size: 14px;
    color: #64686E;
    text-align: center;
    font-weight: 400;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
}
.pc-img-box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  position: relative;
  margin-top: 45px
}
.ph-img-box {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.detection_content {
  margin-top: 24px;
}
.detection_content_right_cont10_ever {
  width: 250px;
  margin-bottom: 40px;
  margin-right: 66px;
  float: left;
  .bigBoxever_img {
    margin-left: 0;
  }
}
.detection_content_right_cont10_ever:nth-child(4n) {
  margin-right: 0px;
}
.detection_content_right_cont10s {
  margin-top: 42px;
}
.m_detection_content_right_cont10_ever {
  margin: 0 auto 40px auto;
}
.detection_content_right_title {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 0;
}
.detection_content_right_cont16_info img {
  max-width: 100%;
  height: auto !important;
}
.detection_content_right_cont16_info {
  margin-top: 65px;
  margin-bottom: 65px;
  img {
    max-width: 100%;
    height: auto !important;
  }
}
.phdetection_content_right_cont16_info {
  max-width: 100%;
  margin-top: 20px;
  img {
    max-width: 100%;
    height: auto !important;
  }
}
.phdetection_content_right_cont16_info img{
  
    max-width: 100%;
    height: auto !important;
}
.detection_content_right_cont9_ever {
    width: 270px;
    margin-top: 30px;
    margin: 30px auto 0;
}
.classImg {
  width: 270px;
  height: 180px;
  .img {
    width: 270px;
    height: 180px;
  }
}
.detection_content_right_cont16_info >>> p {
  line-height: 1.8;
}

.detection_content_right_cont16_info >>> span {
  line-height: 1.8;
}
.detection_content_left_cont3_ever1 {
    height: 41px;
    display: -webkit-box;
    display: -ms-flexbox;
    float: left;
    -ms-flex-pack: justify;
    -webkit-box-align: center;
    -ms-flex-align: center;
    cursor: pointer;
    margin-left: 18px;
    margin-right: 18px;
}
.flx {
  display: flex;
  justify-content: space-between;
}
.table-hader {
  width:100%;
  width:-moz-fit-content;
  width:-webket-fit-content;
  margin:auto;
  display: flex;
  font-size: 20px;
  
  font-weight: 500;
  justify-content: center;
  border-bottom: 1px solid #EAEBEE;
}
.top-bottom {
  width: 70%;
  display: flex;
  flex-direction:column;
  padding-left: 10px;
}
.detection_content_left {
  width: 100%;
}
.detection_content_right {
  width: 100%;
}
.detection_content_left_cont3_ever_text {
  font-size: 20px !important;
}

// 移动端
.m_table_hader {
  width:100%;
  width:-moz-fit-content;
  width:-webket-fit-content;
  margin:auto;
  display: flex;
  
  font-weight: 500;
  justify-content: center;
  border-bottom: 1px solid #EAEBEE;
}
.m_detection_content_left_cont3_ever_text {
  font-size: 14px;
}
// .solution_bgbox_div {
//   div {
//     position: relative;
//     .a {
//       position: absolute !important;
//       top: 0%;
//     }
//     .b {
//       position: absolute !important;
//       top: 0%;
//     }
//   }
//   .solution_bgbox {
//     margin:0 auto;
//     display: block;
//   }
// }

.pc-company-profile{
  .company-profile {
    width:100%;
    height:400px;
    margin-top:80px;
    .company-profile-left {
      width:48%;
      height:100%;
      .company-profile-title {
        width: 160px;
        height: 48px;
        
        font-size: 40px;
        color: #1E203C;
        text-align: left;
        line-height: 48px;
        font-weight: 500;
        margin-bottom: 24px;
      }
      .company-profile-center {
        
        font-size: 18px;
        color: #64686E;
        text-align: justify;
        line-height: 32px;
        font-weight: 400;
      }
      .company-profile-center p:nth-child(2){
        margin: 14px 0;
      }
    }
    .company-profile-img {
      width:48%;
      height:100%;
      img {
        width: 100%;
      }
    }
  }  
  .company-profile-bottom {
    margin-top: 74px;
    .profile-bottom-center div:nth-child(2) {
      margin:0 40px;
    }
    .profile-bottom-center {
      display: flex;
      justify-content: space-between;
      height:100px;
      .stree {
        position: relative;
        height: 100%;
        width: calc(34% - 20px); 
        background: #FFFFFF;
        border: 1px solid #A8DBFF;
        border-radius: 4px;
        .stree-top {
          padding: 0 16px;
          font-size: 24px;
          position: absolute;
          
          font-weight: 500;
          text-align: left;
          color: rgba(3, 152, 255);
          background-color: #fff;
          // transform: translate(50%, -50%);
          left: 24px;
          top: 0;
          transform: translateY(-50%);
        }
        .stree-center {
          
          font-size: 20px;
          font-weight: 400;
          color: #1E203C;
          padding-left: 40px;
          height: 100px;
          line-height: 100px;
        }
      }
    }
    .stree2 {
      margin-top: 54px;
      position: relative;
      height: 100%;
      width: 100%; 
      background: #FFFFFF;
      border: 1px solid #A8DBFF;
      border-radius: 4px;
      .stree-top {
        padding: 0 16px;
        font-size: 24px;
        position: absolute;
        
        font-weight: 500;
        text-align: left;
        color: rgba(3, 152, 255);
        background-color: #fff;
        // transform: translate(50%, -50%);
        left: 24px;
        top: 0;
        transform: translateY(-50%);
      }
      .stree-center {
        
        font-size: 20px;
        font-weight: 400;
        color: #1E203C;
        padding-left: 40px;
        height: 100px;
        line-height: 100px;
      }
      .stree-center2 {
        display: block;
        font-size: 20px;
        font-weight: 400;
        color: #1E203C;
        padding: 40px 0 40px 40px;
        span {
          display: block;
        }
      }
      .stree-center2 p:nth-child(2) {
        margin: 9px 0;
      }
    }
    .evaluate {
      margin-top: 60px;
      .evaluate-title {
        display: block;
        font-size: 26px;
        color: #1E203C;
        text-align: left;
        margin-bottom: 40px;
      }
      .evaluate-center {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .evaluate-item {
          position: relative;
          width: calc(50% - 20px);
          // width: calc(34% - 20px); 
          height: 240px;
          background: #ffffff;
          border: 1px solid #e1e3ec;
          border-radius: 5px;
          padding: 20px 57px 43px;
          p {
            
            font-size: 20px;
            color: #1E203C;
            text-align: left;
            line-height: 36px;
            font-weight: 500;
          }
          .evaluate-item-center {
            margin-top: 28px;
            display: flex;
            // justify-content: space-between;
            img {
              width: 100%;
            }
            .top-bottom {
              width: 75% ;
            }
            .evaluate-name {
              
              font-size: 20px;
              color: #64686E;
              text-align: left;
              font-weight: 500;
            }
            .evaluate-job {
              line-height: 41px;
              font-size: 16px;
              color: #64686E;
              text-align: left;
              font-weight: 400
            }
          }
        }
      }
    }
    .client {
      margin-top: 60px;
      .client-title {
        display: block;
        font-size: 26px;
        color: #1E203C;
        text-align: left;
        margin-bottom: 40px;
      }
      .client-center {
        width: 100%;
        margin-bottom: 20px;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: justify;
        flex-wrap: wrap;
        .client-center-box {
          width: 240px;
          height: 118px;
          background: #FFFFFF;
          border: 1px solid #E1E3EC;
          cursor: default;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
::v-deep.el-tooltip__popper.is-dark {
    background: #303133;
    color: #FFF;
    opacity: 0.7;
}
::v-deep.ph-company-profile{
  
  padding: 0 20px;
  .company-profile {
    width:100%;
    display: block !important;
    .company-profile-left {
      width:100%;
      height:100%;
      .company-profile-title {
        width: 160px;
        height: 48px;
        
        font-size: 16px;
        color: #1E203C;
        text-align: left;
        line-height: 48px;
        font-weight: 500;
        margin-bottom: 3px;
      }
      .company-profile-center {
        
        font-size: 14px;
        color: #64686E;
        text-align: justify;
        line-height: 30px;
        font-weight: 400;
      }
      .company-profile-center p:nth-child(2){
        margin: 14px 0;
      }
    }
    .company-profile-img {
      overflow: hidden;
      width:100%;
      text-align: center;
      height:100%;
      img {
        width: 100%;
      }
    }
  }  
  .company-profile-bottom {
    margin-top: 38px;
    .profile-bottom-center div:nth-child(2) {
      margin-top:28px;
    }
    .profile-bottom-center div:nth-child(3) {
      margin-top:28px;
    }
    .profile-bottom-center {
      display: block;
      width: 100%;
      .stree {
        position: relative;
        height: 100%;
        width: 100%; 
        background: #FFFFFF;
        border: 1px solid #A8DBFF;
        border-radius: 4px;
        .stree-top {
          padding: 0 16px;
          font-size: 15px;
          position: absolute;
          
          font-weight: 500;
          text-align: left;
          color: rgba(3, 152, 255);
          background-color: #fff;
          // transform: translate(50%, -50%);
          left: 24px;
          top: 0;
          transform: translateY(-50%);
        }
        .stree-center {
          
          font-size: 13px;
          font-weight: 400;
          color: #1E203C;
          padding-left: 40px;
          height: 100px;
          line-height: 100px;
        }
      }
    }
    .stree2 {
      margin-top: 28px;
      position: relative;
      height: 100%;
      width: 100%; 
      background: #FFFFFF;
      border: 1px solid #A8DBFF;
      border-radius: 4px;
      .stree-top {
        padding: 0 16px;
        font-size: 15px;
        position: absolute;
        
        font-weight: 500;
        text-align: left;
        color: rgba(3, 152, 255);
        background-color: #fff;
        // transform: translate(50%, -50%);
        left: 24px;
        top: 0;
        transform: translateY(-50%);
      }
      .stree-center {
        display: block;
        
        font-size: 13px;
        font-weight: 400;
        color: #1E203C;
        padding: 40px 40px 40px 40px;
      }
      .stree-center2 {
        display: block;
        
        font-size: 13px;
        font-weight: 400;
        color: #1E203C;
        padding: 40px 40px 40px 40px;
        span {
          margin-top: 10px;
          display: block;
        }
      }
      .stree-center2 p:nth-child(2) {
        margin: 9px 0;
      }
    }
    .evaluate {
      margin-top: 30px;
      .evaluate-title {
        display: block;
        font-size: 16px;
        color: #1E203C;
        text-align: left;
        margin-bottom: 30px;
      }
      #toplin {
        border-top: 0px !important;
      }
      .evaluate-center:nth-child(2) {
        // border-top: 0px !important;
        .evaluate-item:nth-child(1) {
          border-top: 1px solid #ebedf5  !important;
          border-left: 1px solid #ebedf5;
          border-right: 1px solid #ebedf5;
          border-bottom: 1px solid #ebedf5;
        }
      }
      .evaluate-center {
        margin-top: 0px;
        width: 100%;
        .evaluate-item:nth-child(1) {
          border-top: 1px solid #ebedf5  !important;
          border-left: 1px solid #ebedf5;
          border-right: 1px solid #ebedf5;
          border-bottom: 1px solid #ebedf5;
        }
        .evaluate-item {
          position: relative;
          width: 100%;
          // width: calc(34% - 20px); 
          height: 220px;
          background: #ffffff;
          border-left: 1px solid #ebedf5;
          border-right: 1px solid #ebedf5;
          border-bottom: 1px solid #ebedf5;
          border-radius: 5px;
          padding: 20px 40px 43px;
          p {
            
            font-size: 15px;
            color: #1E203C;
            text-align: left;
            line-height: 26px;
            font-weight: 500;
          }
          .evaluate-item-center {
            position: absolute;
            bottom: 0;
            margin-bottom: 25px;
            display: flex;
            // justify-content: space-between;
            img {
              width: 64px;
            }
            .evaluate-name {
              
              font-size: 17px;
              color: #64686E;
              text-align: left;
              font-weight: 500;
            }
            .evaluate-job {
              
              font-size: 12px;
              color: #64686E;
              text-align: left;
              margin-top: 1px;
              font-weight: 400
            }
          }
        }
      }
    }
    .client {
      margin-top: 30px;
      .client-title {
        
        display: block;
        font-size: 16px;
        color: #1E203C;
        text-align: left;
        margin-bottom: 30px;
      }
      .client-center {
        margin-bottom: 20px;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        .client-center-box {
          width: 207px;
          height: 100px;
          background: #FFFFFF;
          border: 1px solid #E1E3EC;
          cursor: default;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
<style>
.detection_content_right_cont16_info  img {
  max-width: 100%;
  height: auto !important;
}
.phdetection_content_right_cont16_info img{
  
    max-width: 100%;
    height: auto !important;
}
</style>
<style lang="scss">
.msolutiondetailcontainer{
    img{
      width: 100%!important;
    }
    table{
      width: 100%!important;
    } 
    h1{
      font-size: 16px!important;
      margin-bottom: 10px;
    }
    h1>span{
      font-size: 16px!important;
    }
    p{
      font-size: 14px!important;
      line-height: 26px!important;
      span{
        font-size: 14px!important;
        line-height: 26px!important;
      }
    }
}
.ph-bigbox-center {
        padding:0 14px;
        .pc-everbox {
            display: flex;
            width: 100%;
            padding: 12px 0;
            border-bottom: 1px solid #f4f6fc;
            .pc-img {
                display: block;
                width: 47%;
                height: 92px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .pc-everbox-center {
                
                width: 70%;
                position: relative;
                .pc-data {
                    font-size: 11px;
                    position: absolute;
                    color: #9698a0;
                    right: 6px;
                    bottom: 0;
                }
                .pc-center {
                    font-size: 13px;
                    font-weight: 600;
                    color: #64686e;
                    font-family: PingFangSC-Bold;
                    position: absolute;
                    left: 12px;
                    text-align: justify;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; 
                    overflow: hidden;
                }
                .pc-look {
                    display: none;
                }
            }
        }
    }
    .pc-bigbox-center {
        width: 100%;
        display: -webkit-box;
        display: flex;
        margin-top: 80px;
        -webkit-box-pack: justify;
        flex-wrap: wrap;
        .pc-everbox {
            width:357px;
            margin-bottom: 60px;
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;
            margin-right: 64px;
            &:nth-child(3n) {
                margin-right: 0;
            }
            .pc-img {
                display: block;
                box-sizing: border-box;
                width: 357px;
                height: 238px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .pc-everbox-center {
                padding:20px;
                box-sizing:border-box;
                border: 1px solid #E1E3EC;
                border-radius: 0 0 4px 4px;
                border-top: 0px;
                .pc-look {
                    margin-top: 5px;
                    color:#122266;
                    font-size: 16px;
                }
                .pc-data {
                    width: 79px;
                    height: 14px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #9698a0;
                    text-align: left;
                    line-height: 14px;
                    font-weight: 400;
                }
                .pc-center {
                    width: 317px;
                    height: 52px;
                    font-family: PingFangSC-Medium;
                    font-size: 18px;
                    color: #64686E;
                    text-align: justify;
                    line-height: 26px;
                    font-weight: 500;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; 
                    overflow: hidden;
                }
                .pc-center:hover {
                    width: 317px;
                    height: 52px;
                    font-family: PingFangSC-Medium;
                    font-size: 18px;
                    color: #122266;
                    line-height: 26px;
                    font-weight: 500;
                }
            }
        }
    }
    
.pcsolutiondetailcontainer{
    img{
      width: 100% !important;
    }
    table{
      // max-width: 1200px!important;
    }
    h1{
      font-size: 22px!important;
      margin-bottom: 20px;
      span{
        font-size: 22px!important;
      }
    }
    p{
      font-size: 18px!important;
      line-height: 33px!important;
      span{
        font-size: 18px!important;
        line-height: 33px!important;
      }
    }
}
.standard-set-meal-search-query-not-fond{
    position: absolute;
    display: inline-block;
    top: 244px;
    width: 270px;
    height: auto;
    word-wrap: break-word;
    background: #000000;
    opacity: 0.5;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
}
.certificateStatus-table {
  width: 100%;
  margin-top: 20px;
  .el-table__header {
    th {
      background: #ebedf9!important;
    }
    .cell{
      color: #1E203C!important;
      font-size: 16px;
    }
  }
  .cerStatus-con {
    display: flex;
    align-items: center;
    justify-content: center;
    .tag {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }
}
.mcertificateStatus-table {
  .cell{
    font-size: 12px!important;
  }
}
.el-tooltip__popper{
  max-width: 500px!important;
}
.certificateSearch-dialog,.mcertificateSearch-dialog {
  .el-button{
    height: 36px;
    line-height: 0;
    border: 1xp solid #122266!important;
    color: #122266;
  }
  .certificateSearch-btn{
    background: #122266;
    color: #FFFFFF;
  }
}
.certificateSearch-dialog {
  .el-dialog {
    width: 500px!important;
  }
}
.mcertificateSearch-dialog {
  .el-dialog {
    width: 300px!important;
  }
  .el-input {
    width: 80%!important;
  }
}
</style>